import { render, staticRenderFns } from "./manifest_modal.vue?vue&type=template&id=2f24f429&scoped=true&"
import script from "./manifest_modal.vue?vue&type=script&lang=js&"
export * from "./manifest_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f24f429",
  null
  
)

export default component.exports